import { render, staticRenderFns } from "./s_WizardServerRoot.vue?vue&type=template&id=e12bbcf6&scoped=true&"
import script from "./s_WizardServerRoot.vue?vue&type=script&lang=js&"
export * from "./s_WizardServerRoot.vue?vue&type=script&lang=js&"
import style0 from "./s_WizardServerRoot.vue?vue&type=style&index=0&id=e12bbcf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12bbcf6",
  null
  
)

export default component.exports